import moment from "moment";
let statusCode = ''

export function GetURLParameter(sParam) {
  let sPageURL = window.location.search.substring(1)
  let sURLVariables = sPageURL.split('&')

  for (let i = 0; i < sURLVariables.length; i++) {
    let sParameterName = sURLVariables[i].split('=')
    if (sParameterName[0].toUpperCase() === sParam.toUpperCase()) {
      return sParameterName[1]
    }
  }
}

export const downloadFilePlain = (text) => {
  const element = document.createElement('a')
  const file = new Blob([text], { type: 'text/plain' })
  element.href = URL.createObjectURL(file)
  element.download = 'BulkUsersUploadFile.txt'
  document.body.appendChild(element)
  element.click()
}

let iso8601DurationRegex = /(-)?P(?:([.,\d]+)Y)?(?:([.,\d]+)M)?(?:([.,\d]+)W)?(?:([.,\d]+)D)?T(?:([.,\d]+)H)?(?:([.,\d]+)M)?(?:([.,\d]+)S)?/

export const parseISO8601Duration = (window.parseISO8601Duration = function (
  iso8601Duration,
) {
  let matches = iso8601Duration.match(iso8601DurationRegex)

  return {
    sign: matches[1] === undefined ? '+' : '-',
    years: matches[2] === undefined ? 0 : matches[2],
    months: matches[3] === undefined ? 0 : matches[3],
    weeks: matches[4] === undefined ? 0 : matches[4],
    days: matches[5] === undefined ? 0 : matches[5],
    hours: matches[6] === undefined ? 0 : matches[6],
    minutes: matches[7] === undefined ? 0 : matches[7],
    seconds: matches[8] === undefined ? 0 : matches[8],
  }
})

export const toCamelCaseFirstLetter = (inputArray) => {
  let result = ''

  for (let i = 0, len = inputArray.length; i < len; i++) {
    let currentStr = inputArray[i]

    let tempStr = currentStr.toUpperCase()

    if (i !== 0) {
      // convert first letter to upper case (the word is in lowercase)
      tempStr = tempStr.substr(0, 1).toLowerCase() + tempStr.substr(1)
    }

    result += tempStr
  }

  return result
}

export const formatDate_ddmmyy = (input) => {
  let output =  moment(input, "YYYY-MM-DD").format(
    "YYYY-MM-DD"
  )
  return output
}


export const format_start_date_ISO = (date) => {
  let day = date.getUTCDate()
  let month = date.getUTCMonth() + 1
  let year = date.getUTCFullYear()
  if(month < 10) {
    month = '0' + month
  }
  if(day < 10) {
    day = "0" + day
  }
  return year + "-" + month + "-" + day + 'T' + "00:00:00.000Z"
}

export const format_end_date_ISO = (date) => {
  let day = date.getUTCDate()
  let month = date.getUTCMonth() + 1
  let year = date.getUTCFullYear()
  if(month < 10) {
    month = '0' + month
  }
  if(day < 10) {
    day = "0" + day
  }
  return year + "-" + month + "-" + day + 'T' + "23:59:00.000Z"
}

export const format_date_UTC = (date) => {
  let day = date.getUTCDate();
  let month = date.getUTCMonth() + 1;
  let year = date.getUTCFullYear();
  let min = date.getUTCMinutes();
  let hour = date.getUTCHours();
  if(month < 10) {
    month = '0' + month;
  }
  if(day < 10) {
    day = "0" + day;
  }
  if(hour < 10) {
    hour = "0" + hour;
  }
  if(min < 10){
    min = "0" + min;
  }
  let ISO_STRING = year + "-" + month + "-" + day + 'T' + `${hour}:${min}:00.000Z`;
  let DATE_FORMAT =  year + "-" + month + "-" + day;
  return {
    UTC_HOUR : hour,
    UTC_MINUTE : min,
    UTC_YEAR : year,
    UTC_MONTH : month,
    UTC_DAY : day,
    UTC_ISO_STRING: ISO_STRING,
    UTC_DATE_FORMAT : DATE_FORMAT
  }
}